import React from 'react';
import DSPaper from '../../../../../design-system/Paper/DSPaper';
import DSCircularProgress from '../../../../../design-system/DSCircularProgress';
import { useTheme } from '@mui/material';

const CollectionAssetFileInputLoading = () => {
  const { palette, spacing } = useTheme();
  return (
    <DSPaper
      sx={{
        display: 'flex',
        aspectRatio: '1',
        padding: spacing(4),
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        borderRadius: spacing(3),
        border: `2px dashed ${palette.white[12]}`,
        background: 'transparent',
      }}
    >
      <DSCircularProgress />
    </DSPaper>
  );
};

export default CollectionAssetFileInputLoading;
